'use strict';

export default (width) => {

    const CONFIG = {
        defaultTiles: 5,
        mappings: [
            {checkWidth: () => width <= 497, tiles: 2},
            {checkWidth: () => width >= 498 && width <= 636, tiles: 3},
            {checkWidth: () => width >= 637 && width <= 767, tiles: 4},
        ]
    }

    return {
        getNumberOfTiles: () => {
            const matchingTiles = CONFIG.mappings.filter(mapping => mapping.checkWidth() )
            return matchingTiles.length ? matchingTiles[0].tiles : CONFIG.defaultTiles
        }
    }
}